import { parseDamianHTMLToSlateJSON } from 'components/TextEditor/utils'
import useObituaryPreview from '../hooks/useObituaryPreview'
import TextEditor from 'components/TextEditor'
import React, { useState } from 'react'
import { Form, UpdateForm } from '..'
import { Descendant } from 'slate'
import Select from 'react-select'

interface TemplateProps {
  form: Form
  updateForm: UpdateForm
}

interface SelectedTemplate {
  label: string
  value: string
  template: string
}

const Template: React.FC<TemplateProps> = ({ form, updateForm }) => {
  const { data, isLoading } = useObituaryPreview(form.name, form.birth, form.death)
  const [selectedTemplate, selectTemplate] = useState<SelectedTemplate | undefined>()

  const updateContent = (html: Descendant[]) => {
    updateForm('content', html)
  }

  return (
    <>
      <div className='infoLabel'>
        Wybierz i dostosuj szablon nekrologu
      </div>

      <div className='myInput'>
        <label>Wybierz szablon</label>
        <Select
          options={data
            ? data.map(({ id, name, template }) => ({ label: name, value: id, template }))
            : []}
          isDisabled={isLoading}
          placeholder='Wybierz szablon'
          classNamePrefix='mySelect'
          value={selectedTemplate}
          onChange={(option) => {
            if (!option) return
            updateContent(parseDamianHTMLToSlateJSON(option.template) as any)
            selectTemplate(option)
          }}
        />
      </div>

      <div className='myInput'>
        <label>Treść</label>
        <TextEditor
          disabled={isLoading}
          value={form.content}
          key={selectedTemplate?.value}
          setValue={updateContent}
        />
      </div>
    </>
  )
}

export default Template
